import React, {PropTypes} from 'react';
import {inject, observer} from "mobx-react";
import {observable, autorun, toJS} from 'mobx';
import L from 'leaflet';
import omnivore from 'leaflet-omnivore';

// const leafletURL = "https://api.mapbox.com/styles/v1/mapbox/streets-v10/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic3VoZWwtMTgyIiwiYSI6ImNqemh2MDdjZTB3cjIzaXM5a3FwbWpvbHgifQ.UZyUM8HIQjrbxxS1Dou8gg";
const leafletURL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

@inject('markerStore')
@observer
class LeafletMap extends React.Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  map;
  dispose;
  @observable markers = this.props.markers || [];
  @observable markerIcons = [];
  @observable layerObjects = [];
  @observable renderedLayers = [];

  componentDidMount() {
    const {center: {lat, lng}, id, kmlLayers, zoom} = this.props;
    this.map = L.map(id).setView([lat, lng], zoom || 7);
    L.tileLayer(leafletURL, {
      maxZoom: 18,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map);

    if (!!kmlLayers && kmlLayers.length > 0) {
      this.renderLayers(kmlLayers)
    }

    this.renderMarkers(this.markers)

    // this.dispose = autorun(() => {
    //   if (!!this.markers || this.markers.length !== 0) this.renderMarkers(toJS(this.markers))
    // });
  }

  componentWillReceiveProps(nextProps) {
    let {center: {lat, lng}, kmlLayers, markers, zoom} = nextProps;

    let newMarkers = markers.map(item => item.id);
    let oldMarkers = this.markerIcons.map(item => item.id);
    let additionalMarkers = markers.filter(item => oldMarkers.indexOf(item.id) === -1);
    let removableMarkers = this.markerIcons.filter(item => newMarkers.indexOf(item.id) === -1);

    removableMarkers.map(marker => {
      this.map.removeLayer(marker.icon);
      // marker.icon.unbindPopup();
    });

    this.markerIcons = this.markerIcons.filter(item => newMarkers.indexOf(item.id) > -1);

    this.renderMarkers(additionalMarkers);


    this.layerObjects.map(({layer, object}) => {
      if(!layer.alwaysDisplay){
        this.renderedLayers = this.renderedLayers.filter(item => item !== layer.url)
        this.map.removeLayer(object);
      }
    });

    if (!!kmlLayers && kmlLayers.length > 0) {
      this.renderLayers(kmlLayers)
    }

    // this.markers = markers;
    if (lat !== this.props.center.lat && lng !== this.props.center.lng) {
      this.map.flyTo(new L.LatLng(lat, lng), zoom);
    }
  }

  componentWillUnmount() {
    // this.dispose();
    this.props.markerStore.selectedMarker = null;
  }

  renderLayers = kmlLayers => {
    this.layerObjects = this.layerObjects.filter(item => item.alwaysDisplay);
    kmlLayers.map(layer => {
      if(this.renderedLayers.indexOf(layer.url) === -1){
        let layerObject = omnivore.kml(layer.url);
        layerObject.on('ready', function () {
          if (layer.style) this.setStyle(layer.style)
        });
        layerObject.addTo(this.map);
        this.layerObjects.push({layer, object: layerObject});
        this.renderedLayers.push(layer.url)
      }
    })
  };

  renderMarkers = markers => {
    markers.map(marker => {
      let markerIcon = L.marker([marker.position.lat, marker.position.lng], {icon: L.divIcon({html: `<img id=${'station_marker_image-' + marker.id} src=${marker.icon} style="margin-left: -5px; margin-top: -25px; z-index: 500;"/>`})});
      // if(this.props.renderInfoWindow) markerIcon.bindPopup(this.props.renderInfoWindow(marker, false));

      if (!!this.props.onMarkerClick) {
        markerIcon
          .on('click', () => {
            this.props.onMarkerClick(marker, false);
          })
          .on('mouseover', () => {
            // this.openPopup();
            this.props.markerStore.onMouseoverMarker(marker.id)
            // this.props.onMouseover(marker);
          });
      }
      this.map.addLayer(markerIcon);
      this.markerIcons.push({id: marker.id, icon: markerIcon});
    })
  };

  render() {
    return (
      <div id={this.props.id} style={{height: this.props.height || '60vh', width: this.props.width || '100%'}}>
        {this.props.children}
      </div>
    );
  }
}

LeafletMap.propTypes = {
  id: PropTypes.string.isRequired,
  markers: PropTypes.array.isRequired, // [{id, position: [lat, lng], icon, popupBox}] - popupBox is a stringified html
  center: PropTypes.array.isRequired, // [lat, lng]
  zoom: PropTypes.number,
  height: PropTypes.string,
  width: PropTypes.string,
  kmlLayers: PropTypes.arrayOf(PropTypes.string)
};

export default LeafletMap;


// WEBPACK FOOTER //
// ./src/components/common/LeafletMap.js